/* Progressive mobile layer. The existing purchase controller owns variants, stock, prices and cart submission. */
(() => {
  const mq=window.matchMedia('(max-width:749px)');
  const cleanup=new Map();
  let headerObserver;
  function initHeaderOffset(){
    const header=document.getElementById('header-group');
    if(!header || headerObserver)return;
    const measure=()=>document.body.style.setProperty('--er-lite-header-height',`${Math.ceil(header.getBoundingClientRect().height)}px`);
    measure();
    if('ResizeObserver'in window){headerObserver=new ResizeObserver(measure);headerObserver.observe(header);}
  }
  function initGallery(root,input){
    const source=root.querySelector('[data-er-lite-main-source]');
    const image=root.querySelector('[data-erpdp-main-image]');
    const hero=root.querySelector('[data-er-lite-hero-thumb]');
    const thumbs=[...root.querySelectorAll('[data-erpdp-thumb]')];
    if(!source || !image || !hero || !hero.dataset.src)return ()=>{};
    let variants=[];
    try{variants=JSON.parse(root.querySelector('[data-erpdp-product-json]')?.textContent || '{}').variants || [];}catch{}
    const isStandard=()=>/standard/i.test(variants.find(v=>String(v.id)===input.value)?.title || '');
    const readMedia=()=>({id:image.dataset.mediaId || '',alt:image.alt,thumb:thumbs.find(t=>t.dataset.mediaId===image.dataset.mediaId) || thumbs.find(t=>t.classList.contains('is-active'))});
    let media=readMedia();
    let showHero=isStandard();
    const strip=hero.closest('.erpdp-gallery-thumbs');
    let scrollFrame;
    let disposed=false;
    let viewportWidth=window.innerWidth;
    function queueVisibleThumb(){
      cancelAnimationFrame(scrollFrame);
      if(disposed || !mq.matches || !strip)return;
      // Wait for scroll anchoring after an insertion or any viewport resize.
      // Only adjust the horizontal strip; do not move the page vertically.
      scrollFrame=requestAnimationFrame(()=>{
        scrollFrame=0;
        if(disposed || !root.isConnected || !mq.matches || !strip.clientWidth)return;
        const active=strip.querySelector('.is-active');
        if(!active || active.hidden)return;
        const bounds=strip.getBoundingClientRect(),thumb=active.getBoundingClientRect();
        const left=bounds.left+strip.clientLeft,right=left+strip.clientWidth;
        if(thumb.left<left-1)strip.scrollLeft+=thumb.left-left;
        else if(thumb.right>right+1)strip.scrollLeft+=thumb.right-right;
      });
    }
    function onViewportResize(){
      if(window.innerWidth===viewportWidth)return;
      viewportWidth=window.innerWidth;
      queueVisibleThumb();
    }
    function render(){
      const heroAvailable=mq.matches && isStandard();
      const heroActive=heroAvailable && showHero;
      hero.hidden=!heroAvailable;
      hero.style.display=heroAvailable?'':'none';
      hero.classList.toggle('is-active',heroActive);
      hero.setAttribute('aria-pressed',String(heroActive));
      thumbs.forEach(thumb=>{
        const active=!heroActive && thumb===media.thumb;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-pressed',String(active));
      });
      source.srcset=heroActive?hero.dataset.src:(image.srcset || image.src);
      source.sizes=heroActive?'calc(100vw - 36px)':(image.sizes || 'calc(100vw - 36px)');
      image.alt=heroActive?hero.dataset.alt:media.alt;
      image.dataset.erLiteDisplayedMediaId=heroActive?'lite-mobile-hero':media.id;
      if(!heroAvailable && document.activeElement===hero)media.thumb?.focus({preventScroll:true});
      queueVisibleThumb();
    }
    function onClick(event){
      if(event.target.closest('[data-er-lite-hero-thumb]')){
        showHero=isStandard();
      }else if(event.target.closest('[data-erpdp-variant],[data-erpdp-thumb]')){
        // The existing controller has already updated the underlying product image.
        media=readMedia();
        showHero=Boolean(event.target.closest('[data-erpdp-variant]')) && isStandard();
      }else return;
      render();
    }
    root.addEventListener('click',onClick);
    mq.addEventListener('change',render);
    window.addEventListener('resize',onViewportResize);
    render();
    return ()=>{disposed=true;cancelAnimationFrame(scrollFrame);root.removeEventListener('click',onClick);mq.removeEventListener('change',render);window.removeEventListener('resize',onViewportResize);};
  }
  function initPurchase(){
    const root=document.querySelector('[data-erpdp-purchase]');
    if(!root || root.dataset.erpdpInitialized!=='true' || root.dataset.erLiteSelectReady)return;
    const select=root.querySelector('[data-er-lite-variant-select]');
    const buttons=[...root.querySelectorAll('[data-erpdp-variant]')];
    const input=root.querySelector('[data-erpdp-variant-id]');
    if(!select || !input || !buttons.length)return;
    select.value=input.value;
    select.hidden=false;
    root.dataset.erLiteSelectReady='true';
    const abort=new AbortController();
    const listeners={signal:abort.signal};
    select.addEventListener('change',()=>{
      const target=buttons.find(button=>button.dataset.erpdpVariant===select.value);
      if(target)target.click();
      select.value=input.value;
    },listeners);
    root.addEventListener('click',event=>{
      if(event.target.closest('[data-erpdp-variant]'))select.value=input.value;
    },listeners);
    const disposeGallery=initGallery(root,input);
    const sticky=root.querySelector('[data-erpdp-mobile-cart]');
    const main=root.querySelector('[data-erpdp-add]');
    let observer;
    if(sticky && main && 'IntersectionObserver'in window){
      observer=new IntersectionObserver(entries=>sticky.classList.toggle('er-lite-sticky-away',entries[0].isIntersecting),{threshold:0.5});
      observer.observe(main);
    }
    cleanup.set(root,()=>{abort.abort();disposeGallery();observer?.disconnect();delete root.dataset.erLiteSelectReady;});
  }
  function initSection(section){
    if(section.dataset.erLiteReady)return;
    section.dataset.erLiteReady='true';
    const abort=new AbortController();
    const listeners={signal:abort.signal};
    const observers=[];
    section.querySelectorAll('[data-er-lite-modes]').forEach(group=>{
      const controls=group.querySelector('.er-lite-mode-controls');
      const buttons=[...group.querySelectorAll('[data-er-lite-mode]')];
      const panels=[...group.querySelectorAll('[data-er-lite-mode-panel]')];
      if(!buttons.length || !panels.length)return;
      function select(id){buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.erLiteMode===id)));panels.forEach(p=>p.hidden=p.dataset.erLiteModePanel!==id);}
      controls.hidden=false;
      select(buttons[0].dataset.erLiteMode);
      buttons.forEach(button=>button.addEventListener('click',()=>select(button.dataset.erLiteMode),listeners));
      group.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-er-lite-mode-panel]');if(panel)select(panel.dataset.erLiteModePanel);},listeners);
    });
    section.querySelectorAll('[data-er-lite-video-wrap]').forEach(wrap=>{
      const video=wrap.querySelector('video');
      const play=wrap.querySelector('[data-er-lite-play]');
      const error=wrap.querySelector('[data-er-lite-video-error]');
      if(!video||!play)return;
      video.controls=false;video.tabIndex=0;play.hidden=false;
      const attachPoster=()=>{if(video.dataset.erLitePoster&&!video.poster)video.poster=video.dataset.erLitePoster;};
      if('IntersectionObserver'in window){
        const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){if(mq.matches)attachPoster();}else video.pause();}),{rootMargin:'180px',threshold:0});
        observer.observe(video);observers.push(observer);
      }else attachPoster();
      play.addEventListener('click',async()=>{
        document.querySelectorAll('[data-er-lite-src]').forEach(other=>{if(other!==video)other.pause();});
        attachPoster();if(!video.getAttribute('src'))video.src=video.dataset.erLiteSrc;
        video.controls=true;error.hidden=true;
        try{await video.play();play.hidden=true;video.focus();}catch{play.hidden=true;error.hidden=false;}
      },listeners);
      video.addEventListener('play',()=>{document.querySelectorAll('[data-er-lite-src]').forEach(other=>{if(other!==video)other.pause();});play.hidden=true;},listeners);
    });
    section.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{if(!detail.open)detail.querySelectorAll('video').forEach(v=>v.pause());},listeners));
    cleanup.set(section,()=>{abort.abort();observers.forEach(observer=>observer.disconnect());section.querySelectorAll('video').forEach(v=>v.pause());});
  }
  function revealHash(){
    if(!mq.matches)return;
    const id=location.hash.slice(1);
    const mapped={specifications:'lite-mobile-specifications',compatibility:'lite-mobile-modes',performance:'lite-mobile-performance',care:'lite-mobile-details',faq:'lite-mobile-details',highlights:'lite-mobile-hero',story:'lite-mobile-pack',playbook:'lite-mobile-modes'}[id] || id;
    const target=document.getElementById(mapped);
    if(!target)return;
    if(target.tagName==='DETAILS')target.open=true;
    if(mapped!==id)target.scrollIntoView({behavior:'auto',block:'start'});
  }
  function init(){if(!document.body.hasAttribute('data-er-lite-mobile-template'))return;initHeaderOffset();initPurchase();if(mq.matches)document.querySelectorAll('[data-er-lite-section]').forEach(initSection);revealHash();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{for(const [root,dispose]of cleanup){if(event.target===root || event.target.contains(root)){dispose();cleanup.delete(root);}}});
  mq.addEventListener('change',()=>{if(mq.matches)init();else document.querySelectorAll('[data-er-lite-src]').forEach(v=>v.pause());});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('[data-er-lite-src]').forEach(v=>v.pause());});
  window.addEventListener('hashchange',revealHash);
  document.addEventListener('click',event=>{const link=event.target.closest('a[href^="#"]');if(!link || !mq.matches)return;const target=document.getElementById(link.getAttribute('href').slice(1));if(target?.tagName==='DETAILS')target.open=true;});
})();
